function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import { Colors } from './index';
import ExecutionEnvironment from 'exenv';

if (ExecutionEnvironment.canUseDOM) {
  require('wicg-focus-ring'); // eslint-disable-line global-require

}

var DEFAULT_FOCUS_WIDTH = 3;

var getFocusStyles = function getFocusStyles() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$boxShadows = _ref.boxShadows,
      shadows = _ref$boxShadows === void 0 ? [] : _ref$boxShadows,
      _ref$focusColor = _ref.focusColor,
      focusColor = _ref$focusColor === void 0 ? Colors.SystemBlue60 : _ref$focusColor,
      _ref$focusWidth = _ref.focusWidth,
      focusWidth = _ref$focusWidth === void 0 ? DEFAULT_FOCUS_WIDTH : _ref$focusWidth,
      _ref$shouldUseFocusRi = _ref.shouldUseFocusRing,
      shouldUseFocusRing = _ref$shouldUseFocusRi === void 0 ? true : _ref$shouldUseFocusRi;

  var boxShadows = ["0px 0px 0px ".concat(focusWidth, "px ").concat(focusColor)].concat(_toConsumableArray(shadows)).join(', ');

  if (shouldUseFocusRing) {
    return "\n      outline: none;\n      .js-focus-ring &.focus-ring {\n        outline: none;\n        box-shadow: ".concat(boxShadows, ";\n      }\n    ");
  }

  return "\n    outline: none;\n    box-shadow: ".concat(boxShadows, ";\n  ");
};

export default getFocusStyles;